var exports = {
  "nf": "xdde3148b--c835e0--link",
  "AS": "xdde3148b--c835e0--item",
  "iq": "xdde3148b--c835e0--image-container",
  "Sl": "xdde3148b--c835e0--image",
  "pq": "xdde3148b--c835e0--info",
};

module.exports = exports;
